import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const getProperty = () => api.get("/property").then((r) => r.data);

export const createApplication = (payload) =>
  api.post("/applications", payload).then((r) => r.data);

export const listApplications = () =>
  api.get("/applications").then((r) => r.data);

export const createCheckoutSession = (application_id) =>
  api
    .post("/checkout/create-session", {
      application_id,
      origin_url: window.location.origin,
    })
    .then((r) => r.data);

export const getPaymentLink = (application_id) =>
  api.get(`/payment-link/${application_id}`).then((r) => r.data);

export const markApplicationPaid = (application_id) =>
  api.post(`/applications/${application_id}/mark-paid`).then((r) => r.data);

export const getCheckoutStatus = (session_id) =>
  api.get(`/checkout/status/${session_id}`).then((r) => r.data);
